/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Leadership10Inputs */

const en_job_form_enum_leadership10 = /** @type {(inputs: Job_Form_Enum_Leadership10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leadership`)
};

const de_job_form_enum_leadership10 = /** @type {(inputs: Job_Form_Enum_Leadership10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Führungskompetenz`)
};

/**
* | output |
* | --- |
* | "Leadership" |
*
* @param {Job_Form_Enum_Leadership10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_leadership10 = /** @type {((inputs?: Job_Form_Enum_Leadership10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Leadership10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_leadership10(inputs)
	return en_job_form_enum_leadership10(inputs)
});
export { job_form_enum_leadership10 as "job_form_enum_LEADERSHIP" }